import {
  LICENSE_ICONS,
  SUBSCRIPTIONS_API_KEYS,
} from "features/MySubscriptions/constants/MySubscriptions.constants";
import {
  getPlanByRecurrenceMonths,
  getTenureDisplaySuffix,
  getTenureOptionsFromFeaturePlans,
} from "features/MySubscriptions/utils/tenure.utils";

export const parseLicenseCardData = ({ plan = {}, tenure }) => {
  const {
    [SUBSCRIPTIONS_API_KEYS.feature_key]: key,
    [SUBSCRIPTIONS_API_KEYS.feature_name]: name,
    [SUBSCRIPTIONS_API_KEYS.feature_description]: featureDescription,
    [SUBSCRIPTIONS_API_KEYS.metadata]: metadata = {},
    [SUBSCRIPTIONS_API_KEYS.plans]: tenurePlans = [],
  } = plan || {};

  const selectedTenurePlan =
    getPlanByRecurrenceMonths(tenurePlans, tenure) ??
    getTenureOptionsFromFeaturePlans(tenurePlans)?.[0]?.plan;

  const {
    [SUBSCRIPTIONS_API_KEYS.custom_price]: mrp,
    [SUBSCRIPTIONS_API_KEYS.default_price]: payablePrice,
  } = selectedTenurePlan ?? {};

  return {
    label: name,
    icon: metadata?.icon || LICENSE_ICONS[key],
    info: featureDescription,
    mrp,
    payablePrice,
    tenure: getTenureDisplaySuffix(selectedTenurePlan),
  };
};
